import React, { useCallback, useEffect, useState } from 'react'
import {
    Box,
    Grid,
    Paper,
    Typography,
    List,
    ListItem,
    Avatar,
    ListItemText,
    ListItemIcon,
    TextField,
    TablePagination
} from "@material-ui/core";
import PerfectScrollbar from 'react-perfect-scrollbar';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import NewClinic from './NewClinic';
import Notify from 'src/notification/Notify';
import Axios from 'axios';
import ClinicDetails from './ClinicDetails';

function searchClinic(clinics, query) {
    return clinics.filter((clinic) => {
        let matches = true;

        if (query) {
            let containsQuery = false;

            if (clinic.clinic.toLowerCase().includes(query.toLowerCase())) {
                containsQuery = true;
            }

            if (!containsQuery) {
                matches = false;
            }
        }
        return matches;
    });
}

function applyPagination(clinic, page, limit) {
    return clinic.slice(page * limit, page * limit + limit);
}

const Clinics = () => {

    const token = localStorage.getItem('token')
    const [clinic, setClinic] = useState([])
    const [clinicRd, setClinicRd] = useState(false)
    const [selectedClinic, setSelectedClinic] = useState(null)
    const [query, setQuery] = useState('');
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);

    const getClinics = useCallback(async () => {
        try {
            var formdata = new FormData()
            formdata.set('token', token)
            const request = await Axios.post('gtcadmin/doctors/getclinic-list', formdata)
            setClinic(request.data)
            setClinicRd(true)
        } catch (error) {
            Notify.requestError(error)
        }

    }, [token])

    const handleSearch = (event) => {
        event.persist();
        setQuery(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const filterClinics = searchClinic(clinic, query);
    const paginatedClinic = applyPagination(filterClinics, page, limit);

    useEffect(() => {
        getClinics()
    }, [getClinics])

    return (
        <Box
            m={2}
        >
            <Grid
                container
                spacing={2}
            >
                <Grid item xs={12} sm={4} md={3}>
                    <Box
                        component={Paper}
                        height={'calc(100vh - 120px)'}
                        overflow="hidden"
                    >
                        <Box>
                            <Typography
                                variant="subtitle2"
                                color="textPrimary"
                            >
                                CLINIC LIST
                            </Typography>

                        </Box>
                        <Box my={1}>
                            <TextField
                                fullWidth
                                label="Search Clinic"
                                variant="outlined"
                                margin="dense"
                                onChange={handleSearch}
                                value={query}
                            />
                        </Box>
                        <PerfectScrollbar>
                            <List component={`div`}>
                                <ListItem
                                    button
                                    selected={selectedClinic === null}
                                    onClick={() => setSelectedClinic(null)}
                                >
                                    <ListItemIcon>
                                        <Avatar>
                                            <AddCircleOutlineIcon />
                                        </Avatar>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="New Clinic"
                                        secondary="Add Clinic Form"
                                    />
                                </ListItem>

                                {
                                    clinicRd ?
                                        clinic.length > 0 ?
                                            paginatedClinic.map((data, index) => (
                                                <ListItem
                                                    selected={data.clinic_id === selectedClinic}
                                                    key={index}
                                                    onClick={() => setSelectedClinic(data.clinic_id)}
                                                    button
                                                >
                                                    <ListItemIcon>
                                                        <Avatar>
                                                            {data.clinic.charAt().toUpperCase()}
                                                        </Avatar>
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={data.clinic}
                                                        secondary={
                                                            <Typography className={`gtc-lowercase`} variant="caption" color="textSecondary"> {data.address} </Typography>
                                                        }
                                                    />
                                                </ListItem>
                                            ))
                                            : Notify.noRecord()
                                        : Notify.loading()
                                }
                            </List> 
                        </PerfectScrollbar>
                    </Box>
                    {filterClinics.length > 0 && (
                        <TablePagination
                            component={Box}
                            count={filterClinics.length}
                            labelRowsPerPage="List"
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleLimitChange}
                            page={page}
                            rowsPerPage={limit}
                            rowsPerPageOptions={[5, 10, 25]}
                        />
                    )}
                </Grid>

                <Grid item xs={12} sm={8} md={9}>
                    {selectedClinic === null && (<NewClinic getClinics={getClinics} />)}
                    {selectedClinic !== null && (<ClinicDetails getClinics={getClinics} clinicId={selectedClinic} />)}
                </Grid>
            </Grid>
        </Box>
    )
}

export default Clinics;